import React from 'react';
import { useHistory } from 'react-router-dom'; // Import useHistory
import { useGetUserReviewsReceivedQuery } from '../../redux/apis/endpoints/reviewApi'; // Changed import
import Rating from '../ui/Rating';
import LoadingSpinner from '../ui/LoadingSpinner'; // Using UI spinner for inline display

const UserRatingDisplay = ({ userId, ratingComponentSize = 'base', className = '' }) => {
  const history = useHistory(); // Get history object
  const {
    data: userReviewsReceivedData, // Changed variable name
    isLoading: isLoadingUserReviewsReceived, // Changed variable name
    error: userReviewsReceivedError, // Changed variable name
  } = useGetUserReviewsReceivedQuery(
    { userId: userId, pageSize: 500 }, // Fetching reviews received by this user
    { skip: !userId }
  );

  const handleRatingClick = () => {
    // Navigate to the new dynamic user reviews page
    if (userId) { // Ensure userId is available before navigating
      history.push(`/reviews/user/${userId}`);
    }
  };

  if (!userId) return null; // or some placeholder/message if userId is essential

  const mainContentClass = `flex items-center cursor-pointer hover:opacity-80 transition-opacity ${className}`;

  if (isLoadingUserReviewsReceived) {
    return (
      <div className={mainContentClass} onClick={handleRatingClick}>
        <LoadingSpinner size="sm" />
      </div>
    );
  }

  if (userReviewsReceivedError) {
    // console.error('Error fetching user received reviews:', userReviewsReceivedError);
    // Optionally return a small error indicator or null
    return (
      <div className={mainContentClass} onClick={handleRatingClick}>
        <span className={`text-xs text-red-500`}>Error loading ratings</span>
      </div>
    );
  }

  const relevantReviews = userReviewsReceivedData || [];
  const averageRating = relevantReviews.length
    ? relevantReviews.reduce((sum, comment) => sum + (comment.rating || 0), 0) / relevantReviews.length
    : 0;
  const totalRatings = relevantReviews.length;

  if (totalRatings > 0) {
    return (
      <div className={mainContentClass} onClick={handleRatingClick}>
        <Rating
          rating={averageRating || 0}
          totalRatings={totalRatings}
          size={ratingComponentSize}
        />
      </div>
    );
  }

  return null;
};

export default UserRatingDisplay; 